// src/components/checkout/DeliveryInfo.js
import React from 'react';
import {
  Box,
  Typography,
  Button,
  TextField,
  MenuItem
} from '@mui/material';

const DeliveryInfo = ({
  orderData,
  handleInputChange,
  shippingPrices,
  selectedGovernorate,
  handleGovernorateChange,
  shippingPrice,
  finalShippingPrice,
  hasAllFreeShipping,
  loadingShipping,
  validateDeliveryInfo,
  onNext
}) => {
  // RTL TextField styling - EXACT same as ProductsFilter
  const rtlTextFieldSx = {
    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline legend': {
        textAlign: 'right',
        transformOrigin: 'top right',
        right: 12,
        left: 'auto'
      }
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
      fontWeight: 'bold'
    }
  };

  const handleNextClick = () => {
    if (validateDeliveryInfo()) {
      onNext();
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
        معلومات التوصيل
      </Typography>

      <TextField
        name="fullName"
        label="الاسم الكامل"
        fullWidth
        margin="normal"
        value={orderData.fullName}
        onChange={handleInputChange}
        required
        InputLabelProps={{
          sx: {
            fontWeight: 'bold',
            left: 'auto',
            '&:not(.MuiInputLabel-shrink)': {
              right: 45,   
            },
            '&.MuiInputLabel-shrink': {
              right: 1,
              transform: 'translateX(2px) translateY(-7px) scale(0.75)',
            },
            '& .MuiInputLabel-asterisk': {
              display: 'none',
            },
          }
        }}
        sx={rtlTextFieldSx}
      />
      
      <TextField
        name="phone"
        label="رقم الهاتف"
        fullWidth
        margin="normal"
        value={orderData.phone}
        onChange={handleInputChange}
        required
        placeholder="01xxxxxxxxx"
        InputLabelProps={{
          sx: {
            fontWeight: 'bold',
            left: 'auto',
            '&:not(.MuiInputLabel-shrink)': {
              right: 45,   
            },
            '&.MuiInputLabel-shrink': {
              right: 1,
              transform: 'translateX(-0.5px) translateY(-7px) scale(0.75)',
            },
            '& .MuiInputLabel-asterisk': {
              display: 'none',
            },
          }
        }}
        sx={rtlTextFieldSx}
      />
      
      {/* Governorate Selection */}
      <TextField
        select
        fullWidth
        label="المحافظة"
        value={selectedGovernorate}
        onChange={handleGovernorateChange}
        margin="normal"
        required
        disabled={loadingShipping}
        InputLabelProps={{
          sx: {
            fontWeight: 'bold',
            left: 'auto',
            '&:not(.MuiInputLabel-shrink)': {
              right: 45,   
            },
            '&.MuiInputLabel-shrink': {
              right: 1,
              transform: 'translateX(-3.5px) translateY(-7px) scale(0.75)',
            },
            '& .MuiInputLabel-asterisk': {
              display: 'none',
            },
          }
        }}
        sx={{
          ...rtlTextFieldSx,
          '& .MuiInputBase-input': {
            ...rtlTextFieldSx['& .MuiInputBase-input'],
            // Apply success color to selected text when free shipping
            color: hasAllFreeShipping ? 'success.main' : 'inherit',
          }
        }}
      >
        {loadingShipping ? (
          <MenuItem disabled sx={{ flexDirection: 'row-reverse', fontWeight: 'bold' }}>
            جاري التحميل...
          </MenuItem>
        ) : (
          shippingPrices.map((price) => (
            <MenuItem 
              key={price.id} 
              value={price.id}
              sx={{ flexDirection: 'row-reverse', fontWeight: 'bold' }}
            >
              {price.governorate_name_ar} 
              {hasAllFreeShipping ? 
                ' - شحن مجاني' : 
                ` - ${price.shipping_price.toFixed(2)} جنيه`
              }
            </MenuItem>
          ))
        )}
      </TextField>
      
      <TextField
        name="address"
        label="العنوان بالكامل"
        fullWidth
        margin="normal"
        value={orderData.address}
        onChange={handleInputChange}
        required
        multiline
        rows={2}
        helperText="يرجى كتابة العنوان كاملاً (الشارع، المنطقة، رقم المبني)"
        FormHelperTextProps={{
          sx: {
            fontWeight: 'bold',
          }
        }}
        InputLabelProps={{
          sx: {
            fontWeight: 'bold',
            left: 'auto',
            '&:not(.MuiInputLabel-shrink)': {
              right: 35,   
            },
            '&.MuiInputLabel-shrink': {
              right: 1,
              transform: 'translateX(4px) translateY(-7px) scale(0.75)',
            },
            '& .MuiInputLabel-asterisk': {
              display: 'none',
            },
          }
        }}
        sx={rtlTextFieldSx}
      />

      <TextField
        name="additionalNotes"
        label="ملاحظات إضافية (اختياري)"
        fullWidth
        margin="normal"
        value={orderData.additionalNotes}
        onChange={handleInputChange}
        multiline
        rows={2}
        InputLabelProps={{
          sx: {
            fontWeight: 'bold',
            left: 'auto',
            '&:not(.MuiInputLabel-shrink)': {
              right: 35,   
            },
            '&.MuiInputLabel-shrink': {
              right: 1,
              transform: 'translateX(20px) translateY(-7px) scale(0.75)',
            },
          }
        }}
        sx={rtlTextFieldSx}
      />
      
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <Button
          variant="contained"
          onClick={handleNextClick}
          sx={{ mt: 1, ml: 1, fontWeight: 'bold' }}
        >
          التالي
        </Button>
      </Box>
    </Box>
  );
};

export default DeliveryInfo;
